import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { HttpModule } from "@angular/http";
import { PortalCmctiComponent } from './portal-cmcti/portal-cmcti.component';
import { PortalCmctiModule } from './portal-cmcti/portal-cmcti.module';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { GerenciadorComponent } from './gerenciador/gerenciador.component';
import { GerenciadorModule } from './gerenciador/gerenciador.module';
import { LoginService } from './login/login.service';
import { FileUploadModule } from 'ng2-file-upload';
import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './notification/notification.service';


@NgModule({
  declarations: [
    AppComponent,
    PortalCmctiComponent,
    LoginComponent,
    GerenciadorComponent,
    NotificationComponent,
  ],
  exports: [
    PortalCmctiComponent,
    LoginComponent,
    GerenciadorComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    FormsModule,
    AppRoutingModule,
    // RouterModule.forRoot([]),
    PortalCmctiModule,
    GerenciadorModule,
    FileUploadModule
  ],
  providers: [LoginService,NotificationService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts